import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'primeng/chart';
import { ButtonModule } from 'primeng/button';
import { DashboardServicesService } from '../../services/dashboard-services.service';
import { DashboardPanel } from '../../models/panel';
import { LoginUserModel } from '../../models/loginUserModel';
import { ThemeService } from '../../theme.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-bar-chart',
  standalone: true,
  imports: [CommonModule, ChartModule, ButtonModule],
  templateUrl: './bar-chart.component.html',
  styleUrl: './bar-chart.component.scss'
})
export class BarChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() datasets: any[] = [];
  @Input() method!: string;
  @Input() labels: any[] = [];
  @Input() clientNumber!: number;
  @Input() isDownloadable = false;
  @Input() displayLabel = true;
  @Input() options: any = {};

  data: any;
  chartOptions: any;
  private darkMode = false;
  private sub!: Subscription;
  private user!: LoginUserModel;

  constructor(private dashboardSrv: DashboardServicesService, private themeService: ThemeService) {
    this.darkMode = localStorage.getItem('theme') === 'dark';
    this.user = JSON.parse(localStorage.getItem('data')!);
    this.sub = themeService.changeTheme.subscribe(v => { this.darkMode = v; this.buildOptions(); });
  }

  ngOnInit() { this.buildData(); this.buildOptions(); this.loadDataChart(); }

  ngOnChanges(changes: SimpleChanges) { this.buildData(); this.loadDataChart(); }

  ngOnDestroy() { this.sub?.unsubscribe(); }

  private buildData() {
    this.data = { labels: this.labels, datasets: this.datasets };
  }

  private buildOptions() {
    const color = this.darkMode ? '#fff' : '#182de7';
    this.chartOptions = {
      scales: {
        y: { ticks: { color }, grid: { display: false } },
        x: { ticks: { color }, grid: { display: false } }
      },
      plugins: {
        legend: { display: this.displayLabel, labels: { usePointStyle: true, color, font: { size: 13 } } }
      },
      responsive: true,
      maintainAspectRatio: false
    };
  }

  private loadDataChart() {
    if (this.method) {
      this.dashboardSrv.infoPanel(this.method, this.user.Client_number).subscribe({
        next: (resp: DashboardPanel) => {
          if (resp.type === 'bar') resp.dataChart[0].borderColor = resp.dataChart[0].borderColors;
          this.data = { ...this.data, datasets: resp.dataChart, labels: resp.labelsChart };
        }
      });
    }
  }

  download() {
    const canvas = document.querySelector('p-chart canvas') as HTMLCanvasElement;
    if (canvas) {
      const link = document.createElement('a');
      link.download = 'grafica_consumos.jpg';
      link.href = canvas.toDataURL();
      link.click();
    }
  }
}
